import { __decorate } from "tslib";
import { Component, Mixins, Vue } from "vue-property-decorator";
import * as _ from "lodash";
import simplebar from "simplebar-vue";
import LiquorTree from "liquor-tree";
import Layout from "../../layouts/main.vue";
import Loader from "@/components/widgets/loader.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import { RoleRightCreationRequestModel } from "@/store/models/role/requests/roleRightCreationRequest";
import { toaster } from "@/utilities/toaster";
import { RoleModule } from "@/store/modules/role.module";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
Vue.use(LiquorTree);
let RolesManager = /** @class */ (() => {
    let RolesManager = class RolesManager extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Role Manager";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Security",
                    href: "#",
                },
                {
                    text: "Role Manager",
                    active: true,
                },
            ];
            this.searchKey = "";
            this.selectedRoleId = "";
            this.isMenuDirty = true;
            this.isRightDirty = true;
            this.displayNewSecurityRole = false;
            this.displayingDetails = false;
            this.showLoading = false;
            this.isDetailsLoading = false;
            this.listUnderEdit = null;
            this.isRoleEdit = false;
            this.searchDisabled = false;
            this.rowDisabled = false;
            this.treeUpdate = false;
            this.adminRoleId = "e8430724-0ee4-4d81-944d-440a5a2b7b77";
            this.showDeleteRole = false;
            this.rightsTreeOptions = {
                checkbox: true,
                deletion(node) {
                    return node.checked();
                },
                dnd: false,
            };
        }
        rightChecked(node) {
            if (this.isAdminRoleSelected) {
                node.states.checked = false;
            }
            this.isRightDirty = false;
        }
        rightUnChecked(node) {
            if (this.isAdminRoleSelected) {
                node.states.checked = true;
            }
            this.isRightDirty = false;
        }
        addRole() {
            this.newRole.id = uuidv4();
            this.newRole.name = "";
            this.newRole.description = "";
            this.displayNewSecurityRole = true;
            this.isRoleEdit = false;
            this.rowDisabled = true;
        }
        editRole(role) {
            this.isRoleEdit = true;
            this.newRole.id = role.id;
            this.newRole.name = role.name;
            this.newRole.description = role.description;
            this.rowDisabled = true;
        }
        deleterole(role) {
            this.newRole.id = role.id;
            Swal.fire({
                customClass: {
                    container: "remove-swal2-container",
                    title: "remove-swal2-title",
                    popup: "remove-swal2-popup",
                    icon: "remove-swal2-icon",
                },
                title: `Delete Role?`,
                text: `You won't be able to revert this!`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    RoleModule.DeleteRole(this.newRole.id).then((res) => {
                        if (res) {
                            toaster.ShowSuccess("Role was deleted successfully.");
                        }
                    });
                }
            });
        }
        updateRole() {
            if (!this.newRole.name || !this.newRole.description) {
                toaster.ShowError("Role Name and Description should not be empty.");
            }
            else {
                RoleModule.UpdateRole(this.newRole).then((res) => {
                    if (res) {
                        toaster.ShowSuccess("Role was updated successfully.");
                        this.isRoleEdit = !this.isRoleEdit;
                        this.rowDisabled = false;
                    }
                });
            }
        }
        saveRole() {
            if (!this.newRole.name || !this.newRole.description) {
                toaster.ShowError("Role Name and Description should not be empty.");
            }
            else {
                RoleModule.AddRole(this.newRole).then((res) => {
                    if (res) {
                        toaster.ShowSuccess("Role was saved successfully.");
                        this.displayNewSecurityRole = !this.displayNewSecurityRole;
                    }
                });
                this.rowDisabled = false;
            }
        }
        displaySecurityRole() {
            this.displayNewSecurityRole = false;
            this.rowDisabled = false;
            this.isRoleEdit = false;
        }
        saveRoleRights() {
            var rightTree = this.$refs.rightTree;
            var selection = rightTree.tree.checkedNodes;
            var result = selection.filter((x) => x.parent != null).map((x) => x.id);
            var request = new RoleRightCreationRequestModel();
            request.roleId = this.selectedRoleId;
            request.pages = result;
            RoleModule.SaveRoleRights(request).then((res) => {
                toaster.ShowSuccess(" Role Rights are saved successfully.");
            });
        }
        getRoleRights(role) {
            //this.displayingDetails = false;
            this.isDetailsLoading = true;
            this.selectedRoleId = role.id;
            RoleModule.GetRoleRights(this.selectedRoleId).then((res) => {
                this.displayingDetails = true;
                this.isDetailsLoading = false;
                this.treeUpdate = !this.treeUpdate;
            });
        }
        getRoleName() {
            return this.roles.filter((role) => role.id == this.selectedRoleId)[0].name;
        }
        get newRole() {
            return RoleModule.role;
        }
        get roles() {
            return RoleModule.roles;
        }
        get roleRights() {
            return RoleModule.pages;
        }
        get sortedroleRights() {
            return _.sortBy(this.roleRights, (o) => o.text);
        }
        get filteredRole() {
            if (this.searchKey != "") {
                return RoleModule.roles.filter((x) => x.name.toLowerCase().indexOf(this.searchKey.toLowerCase()) > -1);
            }
            return RoleModule.roles;
        }
        get sortedFilteredRole() {
            return _.sortBy(this.filteredRole, (o) => o.name);
        }
        get isAdminRoleSelected() {
            return this.selectedRoleId == this.adminRoleId;
        }
        created() {
            this.showLoading = true;
            RoleModule.GetRoles().then(() => {
                this.showLoading = false;
            });
        }
        destroyed() { }
    };
    RolesManager = __decorate([
        Component({
            name: "Role",
            components: {
                Layout,
                PageHeader,
                Loader,
                simplebar,
            },
        })
    ], RolesManager);
    return RolesManager;
})();
export default RolesManager;
